import { getUserVisibleOrDefaultExceptionMessage } from '@paragon/client-tools';
import { enqueueError } from '@paragon/notification-tools';
import { addSpinnerMessage, removeSpinnerMessage } from '@paragon/task-spinner';

import { createProjectModel } from '../createProjectModel';
import { AsyncLayoutModelsLibraryThunkAction, LayoutModelsLibraryState } from '../store';
import { projectCreated } from '../store/changeTracker';
import { getLoggedInUserAndOrganizationMaterialSet } from './layoutModelActions';

interface CreateProjectOptions {
  withSpinnerMessage?: string;
}

export const createProject =
  ({ withSpinnerMessage }: CreateProjectOptions = {}): AsyncLayoutModelsLibraryThunkAction<string | undefined> =>
  async (dispatch, getState) => {
    const { loggedInUser, materialSet } = dispatch(getLoggedInUserAndOrganizationMaterialSet());
    if (!loggedInUser || !materialSet) return;

    const spinnerId = withSpinnerMessage ? dispatch(addSpinnerMessage(withSpinnerMessage)) : undefined;

    try {
      const projectName = getNameForNewProject(getState());

      const projectModel = createProjectModel(projectName, materialSet.defaultMaterials, loggedInUser);

      dispatch(projectCreated({ model: projectModel }));

      return projectModel.guid;
    } catch (error) {
      dispatch(enqueueError(getUserVisibleOrDefaultExceptionMessage(error, 'Project creation failed.')));
    } finally {
      if (spinnerId) dispatch(removeSpinnerMessage(spinnerId));
    }
  };

function getNameForNewProject(state: LayoutModelsLibraryState) {
  const projectCount = Object.values(state.layoutModels).filter((model) => model.type === 'project').length;
  return (projectCount + 1).toString();
}
